import { useCallback } from 'react'
import styled from 'styled-components'

const black = '#080A0C'

export const StyledLink = styled.a<{ showUnderline?: boolean }>`
  font-family: 'Matter', 'Roboto', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Oxygen';
  text-decoration: none;
  font-weight: 500;
  font-size: inherit;
  ${({ theme }) => theme.mediaWidth.upToSmall`
    font-size: inherit;
  `}
  /* color: ${({ theme }) => theme.lightGray}; */
  color: ${black};
  cursor: pointer;
  transition: color 0.15s ease;

  :hover {
    text-decoration: ${(props) => (props.showUnderline ? 'underline' : 'none')};
    /* color: #ffffff; */
    /* color: #8EF42E; */
  }
`

export const ExternalLink = ({
  target = '_blank',
  href,
  rel = 'noopener noreferrer',
  showUnderline = false,
  ...rest
}: Omit<React.HTMLProps<HTMLAnchorElement>, 'as' | 'ref' | 'href'> & {
  href: string | null
  showUnderline?: boolean
}) => {
  const handleClick = useCallback(
    (event: React.MouseEvent<HTMLAnchorElement>) => {
      // don't prevent default, don't redirect if it's a new tab
      if (target === '_blank' || event.ctrlKey || event.metaKey) {
      } else {
        event.preventDefault()
      }
    },
    [target],
  )
  return (
    <StyledLink
      showUnderline={showUnderline}
      target={target}
      rel={rel}
      href={href ?? undefined}
      onClick={handleClick}
      {...rest}
    />
  )
}

export const ANoUnderline = styled.a`
  text-decoration: none;
`
